export default "__VITE_ASSET__c5247d72__"